import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import SpinnerComponent from "../../../../../../Components/Loding/Spinner";
import {
    AtualizarEtapaReguaController,
    GetReguaEtapaController,
} from "../../../../../../Controllers/Automacao/Regua/GestaoDeRegua/GestaoDeReguaControllers";
import { IReguaEtapa } from "../../../../../../Interfaces/Automacao/Regua/GestaoDeRegua/GestaoDeReguaInterfaces";

interface IProps {
    idEtapa: number;
    idRegua: number;
    updateList: () => void;
}

interface IFormData extends IReguaEtapa {}

export default function ModalEditarEtapa(props: IProps) {
    const [EtapaRegua, setEtapaRegua] = useState<IReguaEtapa>();

    const { register, handleSubmit, formState } = useForm();

    const updateList = useCallback(() => {
        GetReguaEtapaController(props.idEtapa).then((res) => {
            setEtapaRegua(res);
        });
    }, [props.idEtapa]);

    useEffect(() => {
        updateList();
    }, [updateList]);

    function handleFormSubmit(formData: IFormData) {
        AtualizarEtapaReguaController({
            ID_CASO_COBRANCA_REGUA_ETAPA: props.idEtapa,
            DS_NOME_ETAPA: formData.DS_NOME_ETAPA,
            FL_COBRANCA_PREVENTIVA: formData.FL_COBRANCA_PREVENTIVA,
            ID_CASO_COBRANCA_REGUA: props.idRegua,
            NR_ETAPA: formData.NR_ETAPA,
        }).then(() => {
            updateList();
            props.updateList();
        });
    }

    return EtapaRegua ? (
        <form
            onSubmit={handleSubmit(handleFormSubmit)}
            className="w-100 d-flex justify-content-between align-itens-center mb-3"
        >
            <div className="w-100 h-100">
                <div className="d-flex flew-wrap col-md-12">
                    <div className="m-2 w-50">
                        <h6>Nome Etapa:</h6>
                        <input
                            type="text"
                            name="DS_NOME_ETAPA"
                            className={`form-control placeholder-dark-45 ${
                                formState.errors.DS_ETAPA && "is-invalid"
                            }`}
                            defaultValue={EtapaRegua?.DS_NOME_ETAPA}
                            placeholder="Nome Da Etapa"
                            ref={register({
                                required: "Insira o nome da etapa",
                            })}
                        />
                    </div>
                </div>
                <div className="d-flex flew-wrap col-md-12">
                    <div className="m-2 w-50">
                        <h6>N° Etapa:</h6>
                        <input
                            type="text"
                            name="NR_ETAPA"
                            className={`form-control placeholder-dark-45 ${
                                formState.errors.NR_ETAPA && "is-invalid"
                            }`}
                            placeholder="N° Etapa"
                            defaultValue={EtapaRegua?.NR_ETAPA}
                            ref={register({
                                required: "Insira o número da etapa",
                            })}
                        />
                    </div>
                </div>
                <div className="d-flex flew-wrap col-md-12">
                    <div className="m-2">
                        <h6>Cobrança Preventiva:</h6>
                        <span
                            className="switch switch-outline switch-sm switch-icon switch-success d-flex"
                            data-toggle="tooltip"
                        >
                            <label>
                                <input
                                    defaultChecked={
                                        EtapaRegua?.FL_COBRANCA_PREVENTIVA
                                    }
                                    name="FL_COBRANCA_PREVENTIVA"
                                    ref={register()}
                                    type="checkbox"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>

                <div className="d-flex justify-content-end mr-4">
                    <button className="btn btn-outline-primary font-weight-bold d-flex justify-content-center align-items-center">
                        <FontAwesomeIcon
                            icon={faEdit}
                            size="lg"
                            className="mr-1"
                        />{" "}
                        Editar
                    </button>
                </div>
            </div>
        </form>
    ) : (
        <SpinnerComponent />
    );
}
